import React from 'react';

interface ClientLogoProps {
  clientName: string;
  className?: string;
}

const ClientLogos: React.FC<ClientLogoProps> = ({ clientName, className = "w-full h-full" }) => {
  const getLogoSVG = (name: string) => {
    switch (name.toLowerCase()) {
             case 'softwareedge':
         return (
           <svg viewBox="0 0 120 80" className={className} fill="currentColor">
             {/* SoftwareEdge Logo - Growth Chart Style */}
             <rect x="10" y="50" width="8" height="20" fill="#3b82f6" rx="2"/>
             <rect x="25" y="40" width="8" height="30" fill="#10b981" rx="2"/>
             <rect x="40" y="30" width="8" height="40" fill="#f59e0b" rx="2"/>
             <rect x="55" y="20" width="8" height="50" fill="#ef4444" rx="2"/>
             <text x="70" y="42" fill="#1f2937" fontSize="10" fontWeight="bold">SoftwareEdge</text>
             <text x="70" y="55" fill="#6b7280" fontSize="7">THE PREVAILING</text>
             <text x="70" y="65" fill="#6b7280" fontSize="7">SOLUTION</text>
           </svg>
         );
      
             case 'xrm apptech':
         return (
           <svg viewBox="0 0 120 80" className={className} fill="currentColor">
             {/* XRM APPTECH Logo - Modern Tech Style */}
             <rect x="10" y="20" width="40" height="40" fill="#3b82f6" rx="8"/>
             <path d="M20 30 L30 40 L20 50 M30 30 L40 40 L30 50" stroke="white" strokeWidth="3" fill="none"/>
             <text x="60" y="32" fill="#1f2937" fontSize="12" fontWeight="bold">XRM APPTECH</text>
             <text x="60" y="45" fill="#6b7280" fontSize="7">INNOVATION</text>
             <text x="60" y="55" fill="#6b7280" fontSize="7">DRIVEN</text>
           </svg>
         );
      
             case 'gmr it solutions':
         return (
           <svg viewBox="0 0 120 80" className={className} fill="currentColor">
             {/* GMR IT SOLUTIONS Logo - Cloud Style */}
             <circle cx="25" cy="35" r="15" fill="#3b82f6" opacity="0.8"/>
             <circle cx="35" cy="35" r="15" fill="#10b981" opacity="0.8"/>
             <text x="60" y="32" fill="#1f2937" fontSize="10" fontWeight="bold">GMR IT SOLUTIONS</text>
             <text x="60" y="45" fill="#6b7280" fontSize="7">CLOUD SOLUTIONS</text>
             <text x="60" y="55" fill="#6b7280" fontSize="7">PROVIDER</text>
           </svg>
         );
      
      default:
        return (
          <div className={`${className} bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg flex items-center justify-center`}>
            <span className="text-white font-bold text-lg">{name.charAt(0)}</span>
          </div>
        );
    }
  };

  return getLogoSVG(clientName);
};

export default ClientLogos; 